import { RootState } from '@/shared/store'
import { createSelector } from '@reduxjs/toolkit'

import { columnDefinitionsAdapter } from './columnDefinitionsAdapter'
import { getGridTypeId } from './libs/getGridTypeId'
import { GridTypeName } from './models/GridTypeName'

export const columnDefinitionsSelector = columnDefinitionsAdapter.getSelectors<RootState>(
  (state) => state.columnDefinitions,
)

export const selectColumnDefinitionsByGridType = createSelector(
  [columnDefinitionsSelector.selectAll, (state, gridTypeName: GridTypeName) => getGridTypeId(state.user.businessModel, gridTypeName)],
  (colDefs, gridTypeId) => {
    if (!colDefs) return []

    return colDefs.filter(colDef => colDef.gridTypeId === gridTypeId)
  },
)
